import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import parse, { domToReact } from 'html-react-parser';
import Notification from '../navbars/Notification';
import BrandLogo from "../navbars/BrandLogo";
import '../navbars/_navbars.scss';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from '../../pages/GoogleAnalytics';
import PermissionRequest from './Anti_cheating/PermissionRequest';


class Instructions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            checked: true,
            submitError: "",
            hasPermissions: localStorage.getItem('proctoringBypassed') === 'true',
            proctoringBypassed: localStorage.getItem('proctoringBypassed') === 'true',
            showPermissionModal: false
        }
    }

    async componentDidMount() {

        const bypassed = localStorage.getItem("proctoringBypassed") === "true";

        if (bypassed) {
            this.setState({
                hasPermissions: true,
                proctoringBypassed: true
            });

            if (this.props.onPermissionsGranted) {
                this.props.onPermissionsGranted(true, true);
            }

            return;
        }

        try {
            const permission = await navigator.permissions.query({ name: "camera" });

            if (permission.state === "granted") {

                localStorage.setItem("proctoringBypassed", "true");

                this.setState({
                    hasPermissions: true,
                    proctoringBypassed: true
                });

                if (this.props.onPermissionsGranted) {
                    this.props.onPermissionsGranted(true, true);
                }
            }

        } catch (err) {
        }
    }
    handlePermissionGranted = (bypassed = false) => {
        localStorage.setItem('proctoringBypassed', bypassed ? "true" : "false");
        this.setState({ hasPermissions: true, proctoringBypassed: bypassed, showPermissionModal: false });
        if (this.props.onPermissionsGranted) {
            this.props.onPermissionsGranted(true, bypassed);
        }
    }

    handlePermissionDenied = (error) => {
        this.setState({ hasPermissions: false, showPermissionModal: false });
        if (this.props.onPermissionsGranted) {
            this.props.onPermissionsGranted(false);
        }
    }
    handleOnChange = (e) => {
        if (this.state.checked == true) {
            this.setState({
                checked: false,
                submitError: "Please read the instructions and accept the conditions"
            });
        }
        else {
            this.setState({
                checked: true,
                submitError: "",
            });
        }

    }
    handleStartExam = () => {
        const element = document.documentElement;
        try {
            if (element.requestFullscreen&&this.props.etype === "schedule") {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen&&this.props.etype === "schedule") {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen&&this.props.etype === "schedule") {
                element.msRequestFullscreen();
            }
        } catch (err) {
        }

        localStorage.removeItem('proctoringViolations');
        if (this.props.startPracticeFun) {
            this.props.startPracticeFun();
        }
    }
    submitFun = () => {

    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentemail");

            Cookies.remove("mobile");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("exam_name");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("videos");
            Cookies.remove("branch_name");
            Cookies.remove("role", "");
            Cookies.remove("profile_pic");
            Cookies.remove("student_userlevel");
            Cookies.remove("stulogintype", "");
            const institutionId119 = Cookies.get("institution_id");
            Cookies.remove("institution_id");
            localStorage.removeItem('profile_pic');
            localStorage.removeItem('studentglobals');
            localStorage.removeItem('globalsubjects');
            if (institutionId119 == 119) {
                window.location.href = "https://vignan.rizee.in/login";
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    newTabFunction = () => {
        localStorage.setItem("subjectid", (this.props.history.location.state || {}).subjectid);
        localStorage.setItem("type", "practice");
        localStorage.setItem("ocid", (this.props.history.location.state || {}).ocid);
        localStorage.setItem("otid", (this.props.history.location.state || {}).otid);
        localStorage.setItem("hchaptername", (this.props.history.location.state || {}).hchaptername);
        localStorage.setItem("practice_type", 1);

        window.open("http://localhost:3000/student/subject/practice-test", "_blank") //to open new page
    }
    render() {
        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }
        const isuserValid = JSON.parse(
            isStudentUserValid.user_access_restictions
        );
        let instructions = "";
        let title = "";
        if (this.props.type == "practice") {
            instructions = this.props.examInstructions.find((a) => a.is_exam == "0");
            if (this.props.typeofpractice == "practice") {
                title = GoogleAnalyticsArray[0].Practice_Instructions;
                ReactGA.pageview('/student/subject/practice-test', title);
            }
            else if (this.props.typeofpractice == "error") {
                title = GoogleAnalyticsArray[0].Error_practice_Instructions;
                ReactGA.pageview('/student/subject/practice-errortest', title);
            }

        }
        else {
            instructions = this.props.examInstructions
            title = GoogleAnalyticsArray[0].Exam_Instructions;
            ReactGA.pageview('/student/subject/exam', title);
        }




        return (
            <div className="Instructions">
                <Navbar className="header-top navbar navbar-expand-md navbar-white bg-white shadow-sm">
                    <Container>
                        <Link to="/student/home">
                            <BrandLogo width="159.501" />
                        </Link>

                        <Nav className="ml-auto">
                            {/* <Notification /> */}
                            <NavDropdown id="basic-nav-dropdown2" className="no-arrow" alignRight title={
                                <div className="profile-img d-flex align-items-center">
                                    {localStorage.getItem("profile_pic") ? (

                                        <Image src={`https://support.rizee.in/files/${localStorage.getItem("profile_pic")}`} roundedCircle alt="profile-img" onError={(e) => { e.target.onerror = null; e.target.src = require('../../../images/businessman.png'); }} />
                                    ) : (
                                        <Image src={require('../../../images/businessman.png')} roundedCircle alt="profile-img" />
                                    )}

                                    <div className="text mx-2 mt-2">
                                        <div className="profile-name">{Cookies.get("studentusername")}</div>
                                        <small>Exam- {Cookies.get("exam_name")}, Class - {Cookies.get("classid") == "1" ? ("XI") : ("XII")}</small>
                                    </div>
                                </div>
                            }>
                                <NavDropdown.Item className="font-weight-bold">{Cookies.get("studentemail")}</NavDropdown.Item>
                                <NavDropdown.Divider />
                                {isuserValid.ins_profile_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/profile"><i className="far fa-user mr-2" /> My Profile</NavDropdown.Item>)}
                                {isuserValid.ins_package_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/package"><i className="far fa-sack mr-2" /> Package</NavDropdown.Item>)}

                                <NavDropdown.Item onClick={() => this.setState({ modalShow: true })}><i className="far fa-key mr-2" /> Change Password</NavDropdown.Item>
                                {isuserValid.ins_feedback_tab == true ? ("") : (<NavDropdown.Item as={Link} to="/student/feedback"><i className="far fa-comment-alt-lines mr-2" /> Feedback</NavDropdown.Item>)}
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={Link} onClick={this.logout}><i className="far fa-sign-out mr-2" /> Logout</NavDropdown.Item>
                            </NavDropdown>

                        </Nav>
                    </Container>
                </Navbar>
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-center align-items-center">
                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">{this.props.type == "exam" ? ("Exam") : ("Practice")} Instructions</h6>
                        </div>
                        <div>&nbsp;</div>
                    </Container>
                </div>
                <div className="content-box pt-2" style={{ paddingBottom: '4rem' }}>
                    <Container>
                        <Row>
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <h6 className="mb-2"><u>Please read the following instructions carefully.</u></h6>
                                {instructions != undefined ? (parse(instructions.instructions)) : ("")}
                            </Col>
                        </Row>
                        {this.props.mains2021 == "1" ? (<Row className="mt-4">
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <div class="form-check-inline">
                                    <label class="form-check-label">
                                        <input type="checkbox"
                                            onChange={this.handleOnChange}
                                            className="form-check-input" value="" checked={this.state.checked} />I have red all the instructions and accepted.
                                    </label>
                                </div>
                            </Col>
                        </Row>) : ("")}
                        {this.state.submitError != "" ? (
                            <Row className="mt-1">
                                <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                    <h6 className="text-danger">{this.state.submitError}</h6>
                                </Col>
                            </Row>
                        ) : ("")}
                    </Container>
                </div>

                <div className="bg-white shadow-sm fixed-bottom">
                    <Container>
                        {
                            this.props.stateData?.questions === undefined ? (
                                <Row>
                                    <Col xl={12} lg={12} md={12} className="py-3 text-right">
                                        <span className='text-danger'>* Note:</span> <span>Please try another exam. The questions in this one are not available</span>
                                    </Col>
                                </Row>
                            ) : (
                                <Row>
                                    {this.state.checked == true ? (
                                        <Col xl={12} lg={12} md={12} className="py-3 text-right">
                                            <a
                                                onClick={(() => {
                                                    const proctoringData = (this.props.getAutoSubmitTime && Array.isArray(this.props.getAutoSubmitTime) ? this.props.getAutoSubmitTime[0] : this.props.getAutoSubmitTime) || {};
                                                    const isProctoringEnabled = proctoringData.is_proctoring_enabled && Array.isArray(proctoringData.proctoring_attempt_limit) && proctoringData.proctoring_attempt_limit.length > 0;
                                                    return ((this.props.etype === "schedule" || this.props.etype === "schedulehome") && isProctoringEnabled && !this.state.hasPermissions && !this.state.proctoringBypassed) ? () => this.setState({ showPermissionModal: true }) : this.handleStartExam;
                                                })()}
                                                className="btn btn-outline-primary px-5">
                                                {this.props.type == "exam" ? ("Start Exam") : ("Start Practice")}
                                            </a>
                                        </Col>
                                    ) : (
                                        <Col xl={12} lg={12} md={12} className="py-3 text-right">
                                            <a
                                                onClick={this.submitFun}
                                                className="btn btn-outline-primary px-5">
                                                {this.props.type == "exam" ? ("Start Exam") : ("Start Practice")}

                                            </a>
                                        </Col>
                                    )}
                                </Row>
                            )
                        }

                    </Container>
                </div>
                {this.state.showPermissionModal && (
                    <PermissionRequest
                        onGranted={this.handlePermissionGranted}
                        onDenied={this.handlePermissionDenied}
                    />
                )}
            </div >
        )
    }
}


export default withRouter(Instructions);
